import gql from 'graphql-tag';
import { Shipment, SHIPMENT_FRAGMENT } from '../useShipment/shipment.rest';
import { OrderItem, ORDER_ITEM_FRAGMENT } from '../useOrder/order.rest';

export type GetShipmentListQueryVariables = {
  countryCode: string;
  pageNumber: number;
};

export type GetShipmentListQuery = {
  getShipmentList: {
    __typename: 'RestShipmentList';
    data: Shipment[];
    included: OrderItem[];
    meta: {
      pagination: {
        __typename: 'RestShipmentListMetaPagination';
        totalPages: number;
        currentPage: number;
        previousPage: number | null;
        nextPage: number | null;
        perPage: number;
        totalEntries: number;
      };
    };
  };
};

const SHIPMENT_META_FRAGMENT = gql`
  fragment ShipmentMetaFragment on RestShipmentMeta {
    pagination @type(name: "RestShipmentListMetaPagination") {
      totalPages: total_pages
      currentPage: current_page
      previousPage: previous_page
      totalEntries: total_entries
      nextPage: next_page
      perPage: per_page
    }
  }
`;

export const GET_SHIPMENT_LIST_QUERY = gql`
  query GetShipmentListQuery($countryCode: String!, $pageNumber: Int!) {
    getShipmentList(countryCode: $countryCode, pageNumber: $pageNumber)
      @rest(
        type: "RestShipmentList"
        endpoint: "shipments"
        path: "/v3.5/shipments?include=order_items&country_code={args.countryCode}&page[number]={args.pageNumber}"
      ) {
      data @type(name: "RestShipment") {
        ...ShipmentFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
      meta @type(name: "RestShipmentMeta") {
        ...ShipmentMetaFragment
      }
    }
  }
  ${SHIPMENT_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
  ${SHIPMENT_META_FRAGMENT}
`;
